import type {
  DiffSegment,
  PlainTextFieldDiff,
  RichTextFieldDiff,
} from '@/lib/section-proposal-diff/types';
import { RichTextDiffEditor } from './rich-text-diff-editor';

interface AnnotatedTextProps {
  segments: DiffSegment[];
  className?: string;
}

export function AnnotatedText({ segments, className }: AnnotatedTextProps) {
  return (
    <span className={className}>
      {segments.map((seg, i) => {
        const key = `${seg.type}-${i}`;
        if (seg.type === 'added') {
          return (
            <mark
              key={key}
              className="rounded-sm px-0.5 text-inherit"
              style={{ backgroundColor: 'var(--diff-added)' }}
            >
              {seg.value}
            </mark>
          );
        }
        if (seg.type === 'removed') {
          return (
            <mark
              key={key}
              className="rounded-sm px-0.5 text-inherit line-through opacity-80"
              style={{ backgroundColor: 'var(--diff-removed)' }}
            >
              {seg.value}
            </mark>
          );
        }
        return <span key={key}>{seg.value}</span>;
      })}
    </span>
  );
}

interface AnnotatedRichTextProps {
  fieldDiff: RichTextFieldDiff;
}

// Renders a rich text diff with formatting preserved using the read-only Tiptap compare editor.
export function AnnotatedRichText({ fieldDiff }: AnnotatedRichTextProps) {
  const { proposedHtml, originalHtml } = fieldDiff;

  return (
    <RichTextDiffEditor
      proposedHtml={proposedHtml}
      originalHtml={originalHtml}
      className="tiptap max-w-full"
    />
  );
}

interface AnnotatedPlainTextProps {
  fieldDiff: PlainTextFieldDiff;
  className?: string;
}

export function AnnotatedPlainText({ fieldDiff, className }: AnnotatedPlainTextProps) {
  return <AnnotatedText segments={fieldDiff.segments} className={className} />;
}
